import type { Configuration } from '../../../types/Configuration';

import getCurrencyByCode from '../../libs/utils/currency/getCurrencyByCode';

const getCurrencies = (config: Configuration) => config.supportedCurrencies?.map(getCurrencyByCode) ?? [];

export default getCurrencies;
